import { createSession, adyenCheckout } from '../../actions/adyen';
import {
  cartItems,
  getCart,
  createCart,
  getCartById,
  addItem,
  addItems,
  orderCart,
  orderHistory,
  offlineOrderHistory,
  removeItem,
  shippingMethods,
  setShippingMethod,
  getShippingMethods,
  updateCart,
  updateItem,
  redeemDiscountCode,
  removeDiscountCode,
  getProjectSettings,
  createQuoteRequestFromCurrentCart,
  splitLineItem,
  replicateCart,
  returnItems,
  cancelOrder,
  reassignCart,
  transitionOrderState,
  allSuperUserCarts,
  getAllSuperUserCarts,
} from '../../actions/cart';
import { query, getAttributeGroup, getCategories, getAttributes } from '../../actions/product';
import {
  getMyQuoteRequests,
  getBusinessUserQuoteRequests,
  updateQuoteState,
  updateQuoteRequestState,
} from '../../actions/quotes';
import { getStoresByKey } from '../../actions/stores';
import { getAllSubscriptions } from '../../actions/subscriptions';
import {
  addToWishlist,
  removeLineItem,
  updateLineItem,
  getWishlist,
  getAllWishlists,
  getSharedWishlists,
  fetchStoreWishlists,
  storeWishlists,
  share,
  addToNewWishlist,
  deleteWishlist,
  renameWishlist,
} from '../../actions/wishlist';
import { UseAdyen } from './UseAdyen';
import { UseCart } from './UseCart';
import { UseProducts } from './UseProducts';
import { UseQuotes } from './UseQuotes';
import { UseStores } from './UseStores';
import { UseSubscriptions } from './UseSubscriptions';
import { UseWishlist } from './UseWishlist';

export interface FrontasticState {
  useCart: UseCart;
  useWishlist: UseWishlist;
  useSubscriptions: UseSubscriptions;
  useAdyen: UseAdyen;
  useProducts: UseProducts;
  useQuotes: UseQuotes;
  useStores: UseStores;
}

export const getFrontasticState = (): FrontasticState => {
  return {
    useProducts: {
      query,
      getAttributeGroup,
      categories: getCategories(),
      attributes: getAttributes(),
    },
    useCart: {
      ...cartItems(),
      getCart,
      createCart,
      getCartById,
      addItem,
      addItems,
      updateCart,
      setShippingMethod,
      getShippingMethods,
      removeItem,
      updateItem,
      shippingMethods: shippingMethods(),
      orderCart,
      orderHistory,
      offlineOrderHistory,
      getProjectSettings,
      redeemDiscountCode,
      removeDiscountCode,
      createQuoteRequestFromCurrentCart,
      replicateCart,
      splitLineItem,
      returnItems,
      cancelOrder,
      reassignCart,
      transitionOrderState,
      allSuperUserCarts: allSuperUserCarts(),
      getAllSuperUserCarts,
    },
    useWishlist: {
      getWishlist,
      getAllWishlists,
      getSharedWishlists,
      storeWishlists: storeWishlists(),
      fetchStoreWishlists,
      addToNewWishlist,
      addToWishlist,
      share,
      removeLineItem,
      updateLineItem,
      deleteWishlist,
      renameWishlist,
    },
    useAdyen: {
      createSession,
      adyenCheckout,
    },
    useQuotes: {
      getMyQuoteRequests,
      getBusinessUserQuoteRequests,
      updateQuoteState,
      updateQuoteRequestState,
    },
    useStores: {
      getStoresByKey,
    },
    useSubscriptions: {
      getAllSubscriptions,
    },
  };
};
